import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/index'
// import Home from '@/components/home'
// import btn from '@/components/btn'
const subjectRank = r => require.ensure([], () => r(require('@/components/subjectRank.vue')), 'chunkname1')
const choice = r => require.ensure([], () => r(require('@/components/choice.vue')), 'chunkname2')
const system = r => require.ensure([], () => r(require('@/components/system.vue')), 'chunkname3')
const subject = r => require.ensure([], () => r(require('@/components/subject.vue')), 'chunkname4')
const studentRank = r => require.ensure([], () => r(require('@/components/studentRank.vue')), 'chunkname5')
const appraisal = r => require.ensure([], () => r(require('@/components/appraisal.vue')), 'chunkname6')
const exam = r => require.ensure([], () => r(require('@/components/exam.vue')), 'chunkname7')
const ko = r => require.ensure([], () => r(require('@/components/ko.vue')), 'chunkname8')
const plan = r => require.ensure([], () => r(require('@/components/plan.vue')), 'chunkname9')
const draw = r => require.ensure([], () => r(require('@/components/draw.vue')), 'chunkname10')
const level = r => require.ensure([], () => r(require('@/components/level.vue')), 'chunkname11')


Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/subjectRank',
      name: 'subjectRank',
      component: subjectRank,
      children:[
          
      ]
    },
    {
      path: '/choice',
      name: 'choice',
      component: choice,
       children:[
          
      ]
    },
    {
      path: '/plan',
      name: 'plan',
      component: plan,
       children:[
          
      ]
    },
    {
      path: '/draw',
      name: 'draw',
      component: draw,
       children:[
          
      ]
    },
    {
      path: '/system',
      name: 'system',
      component: system,
       children:[
          
      ]
    },
    {
      path: '/studentRank',
      name: 'studentRank',
      component: studentRank,
       children:[
          
      ]
    },
    {
      path: '/subject',
      name: 'subject',
      component: subject,
       children:[
          
      ]
    },
    {
      path: '/appraisal',
      name: 'appraisal',
      component: appraisal,
       children:[
          
      ]
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam,
       children:[
          
      ]
    },
    {
      path: '/level',
      name: 'level',
      component: level,
       children:[
          
      ]
    },
    {
      path: '/ko',
      name: 'ko',
      component: ko,
       children:[
          
      ]
    }
  ],
  hashbang: false,
  history: true,
  base: '/dist/',
})



// WEBPACK FOOTER //
// ./src/router/index.js